export default __webpack_public_path__ + "static/transition-32dfce399919d0056a72a31307634c2f.mp4";